'use client';
import KYCApprovalWorkflow from './components/KYCApprovalWorkflow';

export default function KYCApprovalPage() {
  return <KYCApprovalWorkflow />;
}
